<div class="flex items-start justify-center p-8 pt-16" style="min-height: calc(var(--vh, 1vh) * 100 - 104px);">
  <div class="w-full max-w-md">
    <!-- Header -->
    <div class="mb-6 text-center">
      <h2 class="text-2xl font-bold mb-2">Set your password</h2>
      <p class="text-sm text-muted-foreground">{{ email }}</p>
    </div>

    <!-- Form -->
    <form [formGroup]="resetPasswordForm" autocomplete="off" class="space-y-4">
      <!-- Password Field -->
      <div class="space-y-2">
        <label hlmLabel for="password" class="text-sm font-medium">Password</label>
        <div class="relative">
          <input
            hlmInput
            id="password"
            formControlName="password"
            [type]="!visiblePwd ? 'password' : 'text'"
            autocomplete="new-password"
            placeholder="Enter your password"
            required
            class="w-full h-11 pr-10"
          />
          <ng-icon
            hlm
            [name]="visiblePwd ? 'lucideEyeOff' : 'lucideEye'"
            (click)="visiblePwd = !visiblePwd"
            class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-muted-foreground hover:text-foreground transition-colors"
          />
        </div>
        @if (passwordControl.hasError('minlength') && passwordControl.touched) {
          <div class="flex items-center gap-2 text-sm text-destructive">
            <ng-icon hlm name="lucideAlertCircle" size="16" />
            <span>Password must be at least {{ passwordControl.getError('minlength').requiredLength }} characters</span>
          </div>
        }
      </div>

      <!-- Confirm Password Field -->
      <div class="space-y-2">
        <label hlmLabel for="confirmPassword" class="text-sm font-medium">Confirm password</label>
        <div class="relative">
          <input
            hlmInput
            id="confirmPassword"
            formControlName="confirmPassword"
            [type]="!visiblePwd ? 'password' : 'text'"
            autocomplete="new-password"
            placeholder="Confirm your password"
            required
            class="w-full h-11 pr-10"
          />
          <ng-icon
            hlm
            [name]="visiblePwd ? 'lucideEyeOff' : 'lucideEye'"
            (click)="visiblePwd = !visiblePwd"
            class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-muted-foreground hover:text-foreground transition-colors"
          />
        </div>
        @if (confirmPasswordControl.hasError('minlength') && confirmPasswordControl.touched) {
          <div class="flex items-center gap-2 text-sm text-destructive">
            <ng-icon hlm name="lucideAlertCircle" size="16" />
            <span>Password must be at least {{ confirmPasswordControl.getError('minlength').requiredLength }} characters</span>
          </div>
        }
      </div>

      <!-- Password Mismatch Error -->
      @if (resetPasswordForm.hasError('passwordMismatch') && arePasswordAndConfirmPasswordTouched) {
        <div class="flex items-center gap-2 text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-md p-3">
          <ng-icon hlm name="lucideAlertCircle" size="16" />
          <span>Passwords do not match</span>
        </div>
      }

      <!-- Submit Button -->
      <button
        hlmBtn
        class="w-full h-11 font-medium mt-6"
        (click)="resetPassword()"
        [disabled]="!resetPasswordForm.valid">
        <ng-icon hlm name="lucideCheck" size="16" class="mr-2" />
        Set password
      </button>
    </form>

    <!-- Helper Text -->
    <p class="text-xs text-center text-muted-foreground mt-4">
      You are signed in as soon as the password is set.
    </p>
  </div>
</div>
